<template>
  <div>
    <v-select
      label="项目类型"
      v-model="projTypeId"
      item-text="name"
      item-value="dbid"
      :items="projTypeItems"
      @change="onProjTypeChange"
    />
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
  import {Bar, Line, mixins} from 'vue-chartjs'

  const uri = '/api/proj/report/five-year-by-type';

  export default {
    extends: Bar,
    mixins: [mixins.reactiveData],
    data() {
      return {
        projTypeId: '',
        projTypeItems: [],
        projTypeLoading: false,

        chartData: null,
        options: {
          responsive: true,
          title: {
            display: false,
            text: ''
          },
          tooltips: {
            mode: 'index',
            intersect: false,
          },
          hover: {
            mode: 'nearest',
            intersect: true
          },
          scales: {
            xAxes: [{
              display: true,
              scaleLabel: {
                display: true,
                labelString: '年度'
              }
            }],
            yAxes: [{
              id: 'y-axis-1',
              type: 'linear',
              display: true,
              position: 'left',
              scaleLabel: {
                display: true,
                labelString: '数量'
              },
              ticks:{
                beginAtZero: true,
              }
            }, {
              id: 'y-axis-2',
              type: 'linear',
              display: true,
              beginAtZero: true,
              position: 'right',
              scaleLabel: {
                display: true,
                labelString: '合同额（万元）'
              },
              ticks:{
                beginAtZero: true,
              },
              gridLines: {
                drawOnChartArea: false
              },
            }]
          }
        }
      }
    },
    created() {

      const vm = this;
      const param = {"sort": "rank.asc", "limit": 999};

      vm.projTypeLoading = true;
      this.axios.get("/api/proj/project-type", {params: param})
        .then(
          rsp => {
            vm.projTypeLoading = false;
            vm.projTypeItems = rsp.data.items;

            vm.projTypeId = 'Db2NlYSLAHg';
            vm.onProjTypeChange('Db2NlYSLAHg');
          })
    },
    mounted() {
      this.renderChart(this.chartData, this.options)
    },
    methods: {
      onProjTypeChange(typeId) {
        const vm = this;
        const param = {"projType": typeId};

        this.axios.get(uri, {params: param})
          .then(
            rsp => {
              vm.chartData = rsp.data;
            })
      }
    }
  }
</script>

<style scoped>

</style>
